// Base fragments for reusable query parts
export const imageFragment = `
  image{
    ...,
    ...asset->{
      "alt": coalesce(altText, originalFilename, "no-alt"),
      "blurData": metadata.lqip,
      "dimensions": metadata.dimensions{
        height,
        width
      },
      "dominantColor": metadata.palette.dominant.background
    },
  }
`;
